import { Grid } from "@mui/material";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useAppSelector } from "../../../Config/Hooks";
import ErrorBoundaryChart from "../../../Shared/Error/ErrorBoudaryChart";
import MapPowertation from "./MapPowerStation/MapPowerstation";
import PowerStationElements from "./PowerStationElements/PowerStationElements";
import TotalizerSynoptic from "./TotalizerSynoptic/TotalizerSynoptic";
import WeatherStationPlant from "./WeatherStationPlant/WeatherStationPlant";
import ActiveAlarms from "./ActiveAlarms/ActiveAlarms";

export default function DashboardPowerPlantLayoutPage() {
    const { selectedPowerPlant } = useAppSelector((state) => state.dashboard);
    const [powerPlantId, setPowerPlantId] = React.useState<number | null>(null);
    const queryClient = new QueryClient();

    React.useEffect(() => {
        if (selectedPowerPlant && selectedPowerPlant.id) {
            setPowerPlantId(selectedPowerPlant.id);
        }
    }, [selectedPowerPlant]);

    return (
        <QueryClientProvider client={queryClient}>
            {powerPlantId ? (
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12} xl={12}>
                        <ErrorBoundaryChart chartName={"Totalizadores"}>
                            <TotalizerSynoptic powerStationId={powerPlantId} />
                        </ErrorBoundaryChart>
                    </Grid>
                    <Grid item container xs={12} spacing={1}>
                        {/*<Grid item xs={12} sm={12} md={12} lg={2} xl={2}>*/}
                        {/*    <GenerationPlant/>*/}
                        {/*    /!*<EnvironmentalDataPlant powerPlantId={selectedPowerPlant.id} />*!/*/}
                        {/*</Grid>*/}
                        <Grid item xs={12} sm={12} md={12} lg={10.3} xl={10.5}>
                            <PowerStationElements powerStationId={powerPlantId} />
                            {/*<EnvironmentalDataPlant powerPlantId={selectedPowerPlant.id} />*/}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={1.7} xl={1.5}>
                            <QueryClientProvider client={queryClient}>
                                <ErrorBoundaryChart key={powerPlantId} chartName={"Dados instantâneos"}>
                                    <WeatherStationPlant powerPlantId={powerPlantId} />
                                </ErrorBoundaryChart>
                            </QueryClientProvider>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <ActiveAlarms powerPlantId={powerPlantId}/>
                    </Grid>
                </Grid>
            ) : null}
        </QueryClientProvider>
    );


}
